import { api } from "../../api/api";
import { applyClientVoiceDefaults } from "./applyClientVoiceDefaults";
import {
  saleDraftNeedsIdentity,
  withSaleIdentityProblem,
} from "./draftProblems";

const asRows = (value) => {
  if (!value) return [];
  return Array.isArray(value) ? value : [value];
};

const responseRows = (res) =>
  (res && res.status >= 200 && res.status < 300 && res.data && res.data.data) ||
  [];

const packageNeedsIdentity = async (pack) => {
  if (pack && pack.requiredAttachment) return true;
  const name = pack && (pack.name || pack.label);
  const id = pack && pack.id;
  if (!name && !id) return false;
  try {
    const res = await api(
      `package?page=1&limit=20&isActive=true&search=${encodeURIComponent(
        name || id
      )}`,
      {},
      "get"
    );
    const rows = responseRows(res);
    const found =
      rows.find((item) => String(item.id) === String(id)) || rows[0];
    return Boolean(found && found.requiredAttachment);
  } catch (error) {
    return false;
  }
};

export const annotateDrafts = async (drafts, context) => {
  const list = applyClientVoiceDefaults(drafts || [], context);
  const next = [];
  for (const draft of list) {
    if (!draft || draft.type !== "sale") {
      next.push(draft);
      continue;
    }
    if (saleDraftNeedsIdentity(draft)) {
      next.push(withSaleIdentityProblem(draft));
      continue;
    }
    let needsIdentity = false;
    const packs = asRows(draft.fields && draft.fields.packages);
    for (const pack of packs) {
      if (await packageNeedsIdentity(pack)) {
        needsIdentity = true;
        break;
      }
    }
    next.push(
      needsIdentity && !(draft.fields && draft.fields.attachment)
        ? withSaleIdentityProblem(draft)
        : draft
    );
  }
  return next;
};
